import { useCallback, useState } from 'react';
import { useNotify } from './use-notify';

const defaultErrorMessage = "Une erreur s'est produite.";

export const useFetch = fetchFunction => {
  const [isLoading, setLoading] = useState(false);
  const [value, setValue] = useState(null);
  const notify = useNotify();

  const fetch = useCallback(
    async (...args) => {
      if (!isLoading) {
        try {
          setLoading(true);
          const data = await fetchFunction(...args);
          setValue(data);
        } catch (err) {
          notify(err.message || defaultErrorMessage, { type: 'error', timeout: 5000 });
        } finally {
          setLoading(false);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetchFunction, notify]
  );

  return { isLoading, value, fetch };
};
